<template>
    <ResumeLoader />
</template>

<script>
    import ResumeLoader from "@/components/apply/ResumeLoader.vue"
    import HFDResumeAction from "@/action/actions/provider/HFDResumeAction"
    import { workflowService } from "@/service"
    import { sessionState } from "@/state"

    export default {
        components: { ResumeLoader },
        async created() {
            await workflowService.invoke(new HFDResumeAction(sessionState.providerKey))
        },
    }
</script>
